import { createSlice } from "@reduxjs/toolkit";
import { searchApi } from "./searchApi";

const initialState = {
  results: [],
  isLoading: false,
  error: null,
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    reset: (state) => {
      state.results = [];
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(searchApi.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(searchApi.fulfilled, (state, action) => {
      state.isLoading = false;
      state.results = action.payload?.data || [];
      state.error = null;
    });
    builder.addCase(searchApi.rejected, (state, action) => {
      state.isLoading = false;
      state.results = [];
      state.error = action.payload?.message || "Failed to fetch search results";
    });
  },
});

export const { reset } = searchSlice.actions;
export default searchSlice.reducer;
